import React, { useState, useEffect } from "react";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography
} from "@material-ui/core";

import Spinner from "../../common/Spinner/Spinner";
import { Button } from "../../common/Button/Button";
import FormModalDigitalEnablementSession from "../JpmcDashboard/FormModalDigitalEnablementSession";

const initialFormData = {
    nResourceInstanceId: "",
    "Learning on Usage": "",
    "Website Link": "",
    "Experience & Effect": "",
    "Usage Clarity & Experience": "",
    "Link to Brand Video": ""
};

export default function PersonaDetailDigitalEnablementTab({
    value,
    index,
    title,
    resourcesDetails,
    setIsFormOpen,
    isFormOpen,
    userDigitalEanblementPersonaDetails,
    uniqueDigitalEnablementInstanceId,
    digitalEnablementInstances,
    isPersonaLoading,
    isTestimonialScreen,
    handleSubmitPersonaDetails,
    handleSubmitDigitalPersonaDetails,
    digitalEnablementAlreadyFilledPersonaInstanceId
}) {

    const [allResourcePersonaDetails, setAllResourcePersonaDetails] = useState([]);
    const [formData, setFormData] = useState(initialFormData);
    const [isEdit, setIsEdit] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const serviceTypeMap = {
        "Social Media Management": "Social Media Service",
        "Online Starter Pack": "Website Design & Development",
        "Website Design & Development": "Website Design & Development",
        "Brand Video": "Brand Video",
        "MeraBills Training": "MeraBills Training"
    };

    function formatDate(dateValue) {
        const date = new Date(dateValue);
        if (isNaN(date)) return "-";
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    // useEffect(() => {

    //     if (resourcesDetails?.Deigital) {

    //         const resources = resourcesDetails.Deigital;

    //         const formatted = resources.map((resourceObj) => {

    //             const findPersona = userDigitalEanblementPersonaDetails?.find(
    //                 (p) => p.nResourceInstanceId === resourceObj.nResourceInstanceId
    //             );

    //             if (findPersona) {
    //                 return {
    //                     ...findPersona,
    //                     ...resourceObj,
    //                     isAlreadyPersonaExisting: true
    //                 };
    //             }

    //             return {
    //                 ...initialFormData,
    //                 ...resourceObj,
    //                 isAlreadyPersonaExisting: false
    //             };

    //         });

    //         setAllResourcePersonaDetails(formatted);

    //     } else {
    //         setAllResourcePersonaDetails([]);
    //     }

    // }, [resourcesDetails, userDigitalEanblementPersonaDetails]);
        useEffect(() => {
    
      if (resourcesDetails?.Deigital) {
    
        const resources = resourcesDetails.Deigital;
    
        const formatted = resources.map((resourceObj) => {
    
          const personaRecords = userDigitalEanblementPersonaDetails?.filter(
            (p) => p.nResourceInstanceId === resourceObj.nResourceInstanceId
          );
    
          const findPersona = personaRecords?.[personaRecords.length - 1];
    
          if (findPersona) {
            return {
              ...findPersona,
              ...resourceObj,
              isAlreadyPersonaExisting: true
            };
          }
    
          return {
            ...initialFormData,
            ...resourceObj,
            isAlreadyPersonaExisting: false
          };
    
        });
    
        setAllResourcePersonaDetails(formatted);
    
      } else {
        setAllResourcePersonaDetails([]);
      }
    
    }, [resourcesDetails, userDigitalEanblementPersonaDetails]);



    // COLUMN VISIBILITY CHECK
    const showMeraBills = allResourcePersonaDetails.some(
        (row) => row.sResourceDisplayName === "Mera Bills"
    );

    const showWebsite = allResourcePersonaDetails.some(
        (row) => row.sResourceDisplayName === "Website Design & Development"
    );

    const showSocialMedia = allResourcePersonaDetails.some(
        (row) => row.sResourceDisplayName === ("Social Media Management" || "Online Starter Pack")
    );

    const showBrandVideo = allResourcePersonaDetails.some(
        (row) => row.sResourceDisplayName === "Brand Video"
    );



    const handleAddEditButton = (rowData, action) => {

        setIsFormOpen(true);
        setFormData(rowData);

        if (action === "edit") {
            setIsEdit(true);
        } else {
            setIsEdit(false);
        }

        setIsModalOpen(true);

    };



    const handleInputChange = (e) => {

        const { name, value } = e.target;

        if (name === "nResourceInstanceId") {

            const selectedResource = digitalEnablementInstances.find(
                (item) => item.nResourceInstanceId === value
            );

            const serviceType =
                serviceTypeMap[selectedResource?.sResourceDisplayName] || "";

            setFormData((prev) => ({
                ...prev,
                nResourceInstanceId: value,
                serviceType
            }));

        } else {

            setFormData((prev) => ({
                ...prev,
                [name]: value
            }));

        }

    };

    if (value !== index) return null;

const getCellStyle = (rowService, targetService) => {
  if (rowService === targetService) {
    return {
      backgroundColor: "#EDE7F6",
    };
  }

  return {
    backgroundColor: "#F5F5F5",
    color: "#9E9E9E",
  };
};



    const renderTable = () => (

        <TableContainer component={Paper} style={{ maxHeight: 420 }}>

            <Table stickyHeader>

                <TableHead>

                    {/* MAIN HEADER */}
                    <TableRow>

                        <TableCell
                            rowSpan={2}
                            style={{ position: "sticky", top: 0, background: "#fff",  }}
                        >
                            Resource Id
                        </TableCell>

                        <TableCell
                            rowSpan={2}
                            style={{ position: "sticky", top: 0, background: "#fff",  }}
                        >
                            Resource Display Name
                        </TableCell>

                        {showMeraBills && (
                            <TableCell
                                colSpan={2}
                                align="center"
                                style={{ position: "sticky", top: 0, background: "#fff",  }}
                            >
                                MeraBills App Training
                            </TableCell>
                        )}

                        {showWebsite && (
                            <TableCell
                                colSpan={2}
                                align="center"
                                style={{ position: "sticky", top: 0, background: "#fff",  }}
                            >
                                Website Development
                            </TableCell>
                        )}

                        {showSocialMedia && (
                            <TableCell
                                colSpan={2}
                                align="center"
                                style={{ position: "sticky", top: 0, background: "#fff",  }}
                            >
                                Social Media Service
                            </TableCell>
                        )}

                        {showBrandVideo && (
                            <TableCell
                                colSpan={3}
                                align="center"
                                style={{ position: "sticky", top: 0, background: "#fff",  }}
                            >
                                Brand Video
                            </TableCell>
                        )}

                        {!isTestimonialScreen && (
                            <TableCell
                                rowSpan={2}
                                style={{ position: "sticky", top: 0, background: "#fff",  }}
                            >
                                Action
                            </TableCell>
                        )}

                    </TableRow>


                    {/* SUB HEADER */}
                    <TableRow>

                        {showMeraBills && (
                            <>
                                <TableCell style={{ position: "sticky", top: 56, background: "#fff", }}>
                                    Training Date
                                </TableCell>
                                <TableCell style={{ position: "sticky", top: 56, background: "#fff",  }}>
                                    Learning on Usage
                                </TableCell>
                            </>
                        )}

                        {showWebsite && (
                            <>
                                <TableCell style={{ position: "sticky", top: 56, background: "#fff",  }}>
                                    Website Delivered Date
                                </TableCell>
                                <TableCell style={{ position: "sticky", top: 56, background: "#fff",  minWidth: 120,maxWidth: 320}}>
                                    Website Link
                                </TableCell>
                            </>
                        )}

                        {showSocialMedia && (
                            <>
                                <TableCell style={{ position: "sticky", top: 56, background: "#fff",  }}>
                                    Service Delivery Date
                                </TableCell>
                                <TableCell style={{ position: "sticky", top: 56, background: "#fff",  }}>
                                    Experience & Effect
                                </TableCell>
                            </>
                        )}

                        {showBrandVideo && (
                            <>
                                <TableCell style={{ position: "sticky", top: 56, background: "#fff",  }}>
                                    Video Delivered Date
                                </TableCell>
                                <TableCell style={{ position: "sticky", top: 56, background: "#fff",  }}>
                                    Usage Clarity & Experience
                                </TableCell>
                                <TableCell style={{ position: "sticky", top: 56, background: "#fff", minWidth: 120,maxWidth: 320 }}>
                                    Link to Brand Video
                                </TableCell>
                            </>
                        )}

                    </TableRow>

                </TableHead>



                <TableBody>

                    {allResourcePersonaDetails.length > 0 ? (

                        allResourcePersonaDetails.map((row, index) => (

                            <TableRow key={index}>

                                <TableCell>{row.nResourceInstanceId}</TableCell>
                                <TableCell>{row.sResourceDisplayName}</TableCell>



                                {showMeraBills && (
                                    <>
                                        <TableCell style={getCellStyle(row.sResourceDisplayName, "Mera Bills")}>
                                            {row.sResourceDisplayName === "Mera Bills"
                                                ? row.dtCreated ? formatDate(row.dtCreated) : '-'
                                                : ""}
                                        </TableCell>

                                        <TableCell style={getCellStyle(row.sResourceDisplayName, "Mera Bills")}>
                                            {row.sResourceDisplayName === "Mera Bills"
                                                ? row["Learning on Usage"]
                                                : ""}
                                        </TableCell>
                                    </>
                                )}



                                {showWebsite && (
                                    <>
                                        <TableCell style={getCellStyle(row.sResourceDisplayName, "Website Design & Development")}>
                                            {row.sResourceDisplayName === "Website Design & Development"
                                                ? row.dtDelivered ? formatDate(row.dtDelivered) : '-'
                                                : ""}
                                        </TableCell>

                                        <TableCell style={getCellStyle(row.sResourceDisplayName, "Website Design & Development")}>
                                            {row.sResourceDisplayName === "Website Design & Development"
                                                ?
                                                 <a
                                                href={row["Website Link"]}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    display: "block",
                                                    whiteSpace: "normal",
                                                    wordBreak: "break-word",
                                                    overflowWrap: "break-word",
                                                    textAlign: "justify",
                                                    color: "#1976d2", 
                                                    textDecoration: "underline", 
                                                }}
                                            >
                                                {row["Website Link"]}
                                            </a>
                                                : ""}
                                        </TableCell>
                                    </>
                                )}



                                {/* {showSocialMedia && (
                                    <>
                                        <TableCell style={getCellStyle(row.sResourceDisplayName, "Social Media Management")}>
                                            {row.sResourceDisplayName === "Social Media Management"
                                                ? row.dtDelivered ? formatDate(row.dtDelivered) : '-'
                                                : ""}
                                        </TableCell>

                                        <TableCell style={getCellStyle(row.sResourceDisplayName, "Social Media Management")}>
                                            {row.sResourceDisplayName === "Social Media Management"
                                                ? row["Experience & Effect"]
                                                : ""}
                                        </TableCell>
                                    </>
                                )} */}
                                {showSocialMedia && (
                                    <>
                                        <TableCell style={(row.sResourceDisplayName === "Social Media Management" ||
                                            row.sResourceDisplayName === "Online Starter Pack")
                                            ? { backgroundColor: "#EDE7F6" }
                                            : { backgroundColor: "#F5F5F5", color: "#9E9E9E" }}>
                                            {(row.sResourceDisplayName === "Social Media Management" ||
                                                row.sResourceDisplayName === "Online Starter Pack")
                                                ? row.dtDelivered ? formatDate(row.dtDelivered) : '-'
                                                : ""}
                                        </TableCell>

                                        <TableCell style={(row.sResourceDisplayName === "Social Media Management" ||
                                            row.sResourceDisplayName === "Online Starter Pack")
                                            ? { backgroundColor: "#EDE7F6" }
                                            : { backgroundColor: "#F5F5F5", color: "#9E9E9E" }}>
                                            {(row.sResourceDisplayName === "Social Media Management" ||
                                                row.sResourceDisplayName === "Online Starter Pack")
                                                ? row["Experience & Effect"]
                                                : ""}
                                        </TableCell>
                                    </>
                                )}


                                {showBrandVideo && (
                                    <>
                                        <TableCell style={getCellStyle(row.sResourceDisplayName, "Brand Video")}>
                                            {row.sResourceDisplayName === "Brand Video"
                                                ? row.dtDelivered ? formatDate(row.dtDelivered) : '-'
                                                : ""}
                                        </TableCell>

                                        <TableCell style={getCellStyle(row.sResourceDisplayName, "Brand Video")}>
                                            {row.sResourceDisplayName === "Brand Video"
                                                ? row["Usage Clarity & Experience"]
                                                : ""}
                                        </TableCell>

                                        <TableCell style={getCellStyle(row.sResourceDisplayName, "Brand Video")}>
                                            {row.sResourceDisplayName === "Brand Video"
                                                ?
                                                <a
                                                    href={row["Link to Brand Video"]}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        display: "block",
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "break-word",
                                                        textAlign: "justify",
                                                        color: "#1976d2",
                                                        textDecoration: "underline",
                                                    }}
                                                >
                                                    {row["Link to Brand Video"]}
                                                </a>
                                                : ""}
                                        </TableCell>
                                    </>
                                )}
                                {/* {showBrandVideo && (
                                    <>
                                        <TableCell style={getCellStyle(row.sResourceDisplayName, "Online Starter Pack")}>
                                            {row.sResourceDisplayName === "Online Starter Pack"
                                                ? row.dtDelivered ? formatDate(row.dtDelivered) : '-'
                                                : ""}
                                        </TableCell>

                                        <TableCell style={getCellStyle(row.sResourceDisplayName, "Online Starter Pack")}>
                                            {row.sResourceDisplayName === "Online Starter Pack"
                                                ? row["Usage Clarity & Experience"]
                                                : ""}
                                        </TableCell>

                                        <TableCell style={getCellStyle(row.sResourceDisplayName, "Online Starter Pack")}>
                                            {row.sResourceDisplayName === "Online Starter Pack"
                                                ? 
                                                <a
                                                href={row["Link to Brand Video"]}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    display: "block",
                                                    whiteSpace: "normal",
                                                    wordBreak: "break-word",
                                                    overflowWrap: "break-word",
                                                    textAlign: "justify",
                                                    color: "#1976d2", 
                                                    textDecoration: "underline", 
                                                }}
                                            >
                                                {row["Link to Brand Video"]}
                                            </a>
                                                : ""}
                                        </TableCell>
                                    </>
                                )} */}



                                {!isTestimonialScreen && (

                                    <TableCell>

                                        {row.isAlreadyPersonaExisting ? (
                                            <Button onClick={() => handleAddEditButton(row, "edit")}>
                                                Edit
                                            </Button>
                                        ) : (
                                            <Button onClick={() => handleAddEditButton(row, "add")}>
                                                Add
                                            </Button>
                                        )}

                                    </TableCell>

                                )}

                            </TableRow>

                        ))

                    ) : (

                        <TableRow>
                            <TableCell colSpan={10} align="center">
                                No Data Found
                            </TableCell>
                        </TableRow>

                    )}

                </TableBody>

            </Table>

        </TableContainer>

    );



    return (

        <Box style={{ padding: 16 }} className={`${isPersonaLoading && "set-opacity"}`}>

            {isPersonaLoading && <Spinner className="center" />}

            <Typography
                variant="h6"
                style={{ fontWeight: "bold", color: "#6D1B7B" }}
            >
                {title}
            </Typography>

            <Box mt={2}>
                {renderTable()}
            </Box>

            <FormModalDigitalEnablementSession
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                formData={formData}
                handleInputChange={handleInputChange}
                uniqueDigitalEnablementInstanceId={uniqueDigitalEnablementInstanceId}
                digitalEnablementInstances={digitalEnablementInstances}
                isEdit={isEdit}
                handleSubmitPersonaDetails={handleSubmitPersonaDetails}
                handleSubmitDigitalPersonaDetails={handleSubmitDigitalPersonaDetails}
                digitalEnablementAlreadyFilledPersonaInstanceId={digitalEnablementAlreadyFilledPersonaInstanceId}
            />

        </Box>

    );

}